/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHeaderStates } from '../../Providers/HeaderStates';
import { Link } from 'react-router-dom';
import { Capa } from '../../components/Capa';
import { Loading } from '../../components/Loading';
import { useStartupState } from '../../Providers/StartupState';
import { baseUrlImg, handleGetData } from '../../Api';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import * as S from './style';

export const RuralCopasul = () => {
  const [data, setData] = useState(null);
  const { setTitle, setBgHeader } = useHeaderStates();
  const { token, setError, loading, setLoading } = useStartupState();

  useEffect(() => {
    setError(null);
    setLoading(true);
    if (token) {
      handleGetData(token, 'api/content/copasul/copasulrural/')
        .then((response) => {
          setData(response?.data?.items[0]?.data);
          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setData(null);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token]);

  // A Capa desenha o título: a faixa verde do Header fica desligada.
  useEffect(() => {
    setTitle(null);
    setBgHeader(null);
  }, [setTitle, setBgHeader]);

  if (loading) {
    return <Loading />;
  } else {
    return (
      <div style={{ position: 'relative' }}>
        <Capa
          imagem={data?.imagemHeader?.iv?.[0]}
          titulo={data?.seo?.iv?.TituloSEO}
        />
        <S.Container bgOurUnits={data?.banner?.iv?.imagemBackground[0]}>
          <img
            src={`${baseUrlImg}${data?.banner?.iv?.imagemSecundaria[0]}`}
            alt="Ciclo Copasul"
          />
          <S.DLBox>
            <S.RuralDescription>
             <ReactMarkdown>
                {data?.banner?.iv?.conteudoMarkdown}
              </ReactMarkdown>
            </S.RuralDescription>
            <S.MidTitle>
              {data?.banner?.iv?.titulo}
            </S.MidTitle>
            <Link
              to={`${data?.banner?.iv?.botaoLink?.linkExterno}`}
              target="_blank"
            >
              <S.SintonizeBox>
                <S.RadioItem>
                  <img
                    src={`${baseUrlImg}${data?.banner?.iv?.imagemSecundaria[0]}`}
                    alt="Copasul Rural"
                    style={{ width: '100px', backgroundColor: '#006e2c', padding: '0.5rem', borderRadius: '1rem'}}
                  />
                </S.RadioItem>
                  <S.RadioItem>
                  <S.RadioItemTop>
                    {data?.cartaomusica?.iv?.subtituloMain}
                  </S.RadioItemTop>
                  <S.RadioItemDescription style={{ fontSize: '0.75rem' }}>
                    {data?.cartaomusica?.iv?.descricaoMain}
                  </S.RadioItemDescription>
                </S.RadioItem>
                <S.RadioItem style={{ marginLeft: '3rem' }}>
                  <S.RadioInnerItem>
                    <S.RadioItemTop>
                      {data?.cartaomusica?.iv?.radios[0]?.subtitulo}
                    </S.RadioItemTop>
                    <S.RadioItemDescription>
                      {data?.cartaomusica?.iv?.radios[0]?.descricao}
                    </S.RadioItemDescription>
                  </S.RadioInnerItem>
                    <S.RadioItemTop>
                    <S.RadioItemTop>
                      {data?.cartaomusica?.iv?.radios[1]?.subtitulo}
                    </S.RadioItemTop>
                    <S.RadioItemDescription>
                      {data?.cartaomusica?.iv?.radios[1]?.descricao}
                    </S.RadioItemDescription>              
                  </S.RadioItemTop>
                </S.RadioItem>
                <S.RadioItem>
                  <S.SpotifyButtonBox style={{ marginLeft: '1rem' }}>
                  <Link
                    to={`${data?.banner?.iv?.botaoLink?.linkExterno}`}
                    target="_blank"
                  >
                  <img 
                    src={`${baseUrlImg}${data?.cartaomusica?.iv?.iconeApp}`}
                    alt="Copasul Rural" 
                    style={{width: '5rem'}}
                  /> 
                  </Link>
                  </S.SpotifyButtonBox>
                </S.RadioItem>
              </S.SintonizeBox>
            </Link>
            <S.MidTitle>
              {data?.banner?.iv?.subtitulo} 
            </S.MidTitle>
            <S.PodcastDescription>
                <ReactMarkdown>
                  {data?.conteudoAdicional?.iv} 
                </ReactMarkdown>
            </S.PodcastDescription>
            <S.PodcastDescription>
                <ReactMarkdown>
                  {data?.markdownAdicional?.iv} 
                </ReactMarkdown>
            </S.PodcastDescription>
          </S.DLBox>
        </S.Container>
      </div>
    );
  }
};

